import React from 'react';
import styled from 'styled-components';

interface id2Props {}

export const Id2: React.FC<id2Props> = () => {
  return <WrapperS className="header-svg" id="authButton" />;
};

const WrapperS = styled.div`
  a svg path {
    stroke: #257d8e;
  }
  a svg circle {
    stroke: #257d8e;
  }
`;
